import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private _http: HttpClient) {}

  public sendFeedback(body: { type_feedback: string; des_feedback: string }): Observable<any> {
    return this._http.post<{ data: any }>(`${environment.apiUrl}/feedback`, body)
    .pipe(
      map(res => res.data),
      catchError((err) => {
        throw err;
      })
    );
  }
}
